import React from 'react';
import { Box, Divider, Flex, Radio, Stack, Text } from '@chakra-ui/react';
import { Heading } from '~/components';
import {
  ContractExtensionProposal,
  ProposalDiscounts,
} from '~/types/extensionProposal';

interface RadioCardProps {
  discount: ProposalDiscounts;
  checkBoxValue: string | undefined;
  handleDiscountSelected: (v: string | undefined) => void;
  data: ContractExtensionProposal;
}

export const RadioCard: React.VFC<RadioCardProps> = ({
  discount,
  checkBoxValue: radio,
  handleDiscountSelected: handleDiscount,
  data,
}) => {
  return (
    <Box
      cursor="pointer"
      borderWidth="2px"
      borderRadius="md"
      boxShadow="1px"
      onClick={() => {
        handleDiscount(discount?.id?.toString());
      }}
      bg={radio === discount.id?.toString() ? '#fcfbff' : ''}
      borderTopColor={radio === discount.id?.toString() ? '#9246ce' : ''}
      _focus={{
        boxShadow: 'outline',
      }}
      px={3}
      py={3}
      width={350}
      minW={350}
      height={280}
    >
      <Stack spacing={4}>
        <Flex justifyContent="space-between">
          <Heading mb={2} fontSize="18px">
            {discount.prazo} meses
          </Heading>
          <Radio value={discount.id?.toString()} colorScheme="b" />
        </Flex>
        <Flex direction="column">
          <Text fontSize="16px">
            De: {data.formattedValorMensalCorrigido?.replace('R$', '')}
            /mês
          </Text>
          <Flex alignItems="baseline">
            <Heading
              color={radio === discount.id?.toString() ? '#9246ce' : ''}
              fontSize="32px"
            >
              {discount.formattedValorCalculado}
            </Heading>
            <Text>/mês</Text>
          </Flex>
        </Flex>
        <Divider dir="horizontal" />
        <Text fontSize="14px">
          Estenda agora com{' '}
          <span style={{ fontWeight: 'bold' }}>
            {discount.formattedDescontoTotal}% de desconto exclusivamente via
            Portal,
          </span>{' '}
          válido até {discount.formattedValidadeDesconto}.
        </Text>
        <Divider dir="horizontal" />
        <Text fontSize="14px">
          Início em:{' '}
          <span style={{ fontWeight: 'bold' }}>
            {discount.formattedInicioExtensao}
          </span>
        </Text>
      </Stack>
    </Box>
  );
};
